import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 3v4l-3.857 6h3.857v4h-6.429l-2.571 4h-3v-4l3.857 -6h-3.857v-4h6.429l2.571 -4l3 0","key":"svg-0"}]]

/**
 * IconBrandDeviantart
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtZGV2aWFudGFydCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTggM3Y0bC0zLjg1NyA2aDMuODU3djRoLTYuNDI5bC0yLjU3MSA0aC0zdi00bDMuODU3IC02aC0zLjg1N3YtNGg2LjQyOWwyLjU3MSAtNGwzIDAiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/brand-deviantart
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandDeviantart = createReactComponent('outline', 'brand-deviantart', 'BrandDeviantart', __iconNode);

export default IconBrandDeviantart;